import { render } from "./TheNotice.vue?vue&type=template&id=087ce912"
import script from "./TheNotice.vue?vue&type=script&lang=js"
export * from "./TheNotice.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\lifet\\workspace\\cna\\cnanonsul-master\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__